import { TRANSITION_STATUS_ENTERING, TRANSITION_STATUS_EXITING, TRANSITION_STATUS_ENTERED, TRANSITION_STATUS_EXITED, TRANSITION_STATUS_UNMOUNTED, } from '@/components/functional/Animation/Transition/Transition';
import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDataListItem のスタイル
 */
export const hotlineProDataListItemStyle = tv({
    defaultVariants: {
        firstDescription: false,
    },
    slots: {
        accordionContent: ['transition-all', 'overflow-hidden'],
        base: [
            'relative',
            'list-none',
            'bg-white',
            'px-16 lg:px-28 pt-36 pb-16',
            'shadow-md',
            'overflow-hidden',
            'md:rounded-md',
        ],
        buttonWrap: ['flex flex-col items-center gap-8', 'mt-32'],
        deadlineTag: ['inline-block', 'mt-16'],
        description: ['flex flex-col lg:flex-row gap-8'],
        descriptionContent: [textStyle({ color: 'base', size: 'sm' }), 'break-all'],
        descriptionTitle: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            'lg:shrink-0',
            'lg:w-[120px]',
        ],
        iconList: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex flex-col lg:flex-row lg:flex-wrap gap-y-12 lg:gap-x-16',
            'mt-12',
        ],
        interviewDate: [textStyle({ color: 'base', size: 'sm' }), 'mt-16'],
        newBadge: ['absolute', 'top-0', 'left-0', 'z-10'],
        openCloseButton: [
            linkTextStyle({ isBold: true }),
            'text-[16px]',
            'flex items-center gap-4',
            'mx-auto mt-24',
        ],
        openCloseButtonIcon: ['self-end', 'transition-transform'],
        remainingText: [textStyle({ color: 'base', isBold: true, size: 'md' })],
        remainingTextStrong: [
            textStyle({ color: 'secondary', isBold: true, size: 'lg' }),
        ],
        rightContent: ['flex flex-col items-center gap-4'],
        title: ['max-lg:line-clamp-2', 'break-all'],
        topContentWrap: ['flex flex-nowrap justify-between gap-8'],
        warningText: [textStyle({ color: 'error', size: 'sm' })],
    },
    variants: {
        firstDescription: {
            false: {
                description: 'mt-20',
            },
            true: {
                description: 'mt-24',
            },
        },
        transitionStatus: {
            [TRANSITION_STATUS_ENTERED]: {
                accordionContent: ['max-h-[auto]'],
                openCloseButtonIcon: ['rotate-180'],
            },
            [TRANSITION_STATUS_ENTERING]: {
                openCloseButtonIcon: ['rotate-180'],
            },
            [TRANSITION_STATUS_EXITED]: {
                accordionContent: ['max-h-[0px]'],
                descriptionContent: ['line-clamp-1'],
            },
            [TRANSITION_STATUS_EXITING]: {
                openCloseButtonIcon: ['rotate-180'],
            },
            [TRANSITION_STATUS_UNMOUNTED]: {},
        },
    },
});
